import type { CSSProperties } from "react";

type Props = {
  src?: string;
  alt?: string;
  ratio: string; // e.g. "4 / 5"
  slot: string; // what goes here, shown in preview placeholders
  spec: string; // dimensions note
  className?: string;
  fit?: "cover" | "contain";
  position?: string;
  reveal?: boolean;
  style?: CSSProperties;
  dark?: boolean;
};

/**
 * Fixed-ratio image frame with a crop reveal. Without a photo it renders a
 * labelled placeholder in preview/dev only; in production builds it renders nothing.
 */
export default function MediaFrame({ src, alt = "", ratio, slot, spec, className = "", fit = "cover", position = "center", reveal = true, style, dark }: Props) {
  if (!src && !import.meta.env.DEV) return null;
  return (
    <figure data-img={reveal ? "" : undefined} className={`ed-frame ${dark ? "ed-frame-dark" : ""} ${className}`} style={{ aspectRatio: ratio, ...style }}>
      {src ? (
        <img src={src} alt={alt} loading="lazy" decoding="async" className="ed-frame-img" style={{ objectFit: fit, objectPosition: position }} />
      ) : (
        <div className="ed-placeholder">
          <span className="ed-placeholder-slot">{slot}</span>
          <span className="ed-placeholder-spec">{spec} · photo needed</span>
        </div>
      )}
    </figure>
  );
}
